import { Component, Inject, ElementRef, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AppAttendanceTypesService } from '../../../core/services/appAttendanceTypesService.service';
import { AppAttendanceTypes } from '../../../core/models/appAttendanceTypes.model';
import { MessageDialog } from '../../../components/message-dialog/messageDialog';

@Component({
  selector: 'app-edit-tipos-dialog',
  templateUrl: './edit-tipos-dialog.component.html',
  styleUrls: ['./edit-tipos-dialog.component.scss'],
  providers: [AppAttendanceTypesService]
})
export class EditTiposDialog {

  panelIcon = 'list'; // font awesome icon
  panelTitle = 'Crear tipo';
  panelDescription = '';
  appAttendanceTypesModel: AppAttendanceTypes;
  @ViewChild('scrollableSection', { static: false }) scrollableSection: ElementRef;
  isNew: boolean = false;



  constructor(
    public dialogRef: MatDialogRef<EditTiposDialog>,
    @Inject(MAT_DIALOG_DATA) public inputData: any,
    public appAttendanceTypesService: AppAttendanceTypesService,
    protected _messageDialog: MessageDialog,

  ) {
    if (inputData.data) {
      this.panelTitle = `Editar tipo (${this.inputData.data.name})`;
      this.appAttendanceTypesModel = inputData.data

    } else {
      this.appAttendanceTypesModel = new AppAttendanceTypes({ name: '', enabled: true, entry: true, imputable: true, company: inputData.companyName });
      this.isNew = true;

    }

  }

  ngOnInit(): void {
  }


  ngAfterViewInit() {
  }

  closePopUp() {
    this.dialogRef.close();
  }

  onEditorPreparing(e): void {
    if (e.parentType === 'searchPanel') {
      e.editorOptions.stylingMode = 'underlined';
    }
  }

  enabledSelectedChange(value: string) {
    if ((value === 'true') !== this.appAttendanceTypesModel.enabled) {
      this.appAttendanceTypesModel.enabled = (value === 'true');
    }
  }

  entrySelectedChange(value: string) {
    if ((value === 'true') !== this.appAttendanceTypesModel.entry) {
      this.appAttendanceTypesModel.entry = (value === 'true');
      this.appAttendanceTypesModel.imputable = (value === 'true');
    }
  }

  imputableSelectedChange(value: string) {
    if ((value === 'true') !== this.appAttendanceTypesModel.imputable) {
      this.appAttendanceTypesModel.imputable = (value === 'true');
    }
  }

  onSubmit(): void {
    this.appAttendanceTypesModel.companyId = this.inputData.companyData.company1;

    if (this.inputData.data) {
      this.appAttendanceTypesService.updateModel(this.appAttendanceTypesModel.attendanceType1, this.appAttendanceTypesModel).subscribe(
        (response) => {
          this.closePopUp();
        },
        (error) => {
          console.error('Error al editar:', error);
        }
      );
    } else {
      this.appAttendanceTypesService.createModel(this.appAttendanceTypesModel).subscribe(
        (response) => {
          this.closePopUp();
        },
        (error) => {
          console.error('Error al crear el registro:', error);
        }
      );
    }

  }




}